var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 3,
    viewBox: "0 0 4 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84712 2.65714C2.48541 2.65714 3.00284 2.1397 3.00284 1.50142C3.00284 0.863135 2.48541 0.345703 1.84712 0.345703C1.20884 0.345703 0.691406 0.863135 0.691406 1.50142C0.691406 2.1397 1.20884 2.65714 1.84712 2.65714Z",
    fill: "url(#paint0_linear_157_650)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_650",
    x1: 1.84712,
    y1: 0.345703,
    x2: 1.84712,
    y2: 2.65714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E80505"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience3);
export default __webpack_public_path__ + "static/media/experience3.90ae91c0340be85217c3c3718d0d5485.svg";
export { ForwardRef as ReactComponent };